import Paleography from './paleography';

export default Paleography;
